import { Fragment } from 'react'
import { cn } from '@/utils/cn'

const URL_RE = /(https?:\/\/[^\s<]+[^\s<.,;:!?)"'])/g

/** Plain text written by teachers and students: paragraphs, line breaks and clickable links. */
export function RichText({ text, className }: { text: string; className?: string }) {
  return (
    <div className={cn('space-y-2 text-sm leading-relaxed text-ink-soft', className)}>
      {text.split(/\n{2,}/).map((para, i) => (
        <p key={i} className="whitespace-pre-line">
          {para.split(URL_RE).map((part, j) =>
            j % 2 === 1 ? (
              <a
                key={j}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                className="break-all text-brand-700 underline underline-offset-2 hover:text-brand-800"
              >
                {part}
              </a>
            ) : (
              <Fragment key={j}>{part}</Fragment>
            ),
          )}
        </p>
      ))}
    </div>
  )
}
